





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { AdminApi } from '@/services/api/api.admin';
import { AdminModule } from '@/store/modules/admin/admin.store';
import { User } from '@/models/user/user.model';
import { ApiPermissions } from '@/core/security/Permissions';
import { Realmlist, UserDetailsViewModel, UserUpdateUserRealmsRequest } from '@/types/apiServerContract';

@Component
export default class EditUserRealms extends Vue {
	@Prop({ required: true })
	user!: User;

	@Prop({ required: true })
	userData!: UserDetailsViewModel;

	permissions: string[] = [ApiPermissions.User.UpdateUserRealms];
	realms: Realmlist[] = [];
	userRealms: number[] = [];
	loading: boolean = false;

	Reset() {
	    this.userRealms = this.userData.user.realms.map(x => x.realmId);
	}

	async UpdateRealms() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;

	    try {
	        const request: UserUpdateUserRealmsRequest = {
	            userId: this.user.id,
	            realms: this.userRealms
	        };
	        await AdminApi.UpdateUserRealms(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast(`${this.user.userName}'s realms have been updated`, {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	async created() {
	    this.realms = await AdminModule.GetRealms();

	    this.Reset();
	}
}
